export default {
    __name: 'no-order',
    setup: function(__props) {
        return {
            __sfc: true
        };
    }
};
